import axios from 'axios';

/**
 * 获取网站名称
 * @returns {Promise<AxiosResponse<T> | never>}
 */
export const getWebInfo = () => {
  return axios.get('/ssc_golang/v1/base/product?random='+new Date().getTime()).then(info => {
    return info.data || {};
  });
};

export const getCode = () => {
  return axios.get('/ssc_golang/v1/base/code?random='+new Date().getTime()).then(info => {
    return info.data || {};
  });
};

export const getDrawList = () => {
  return axios.get('/ssc_golang/v1/results/draw?random='+new Date().getTime()).then(info => {
    return info.data || {};
  });
};

/**
 * 获取用户信息
 * @returns {Promise<AxiosResponse<T> | never>}
 */
export const getUserInfo = () => {
  return axios.get('/ssc_golang/v1/user/userinfo?random='+new Date().getTime()).then(info => {
    return info.data || {};
  });
};


/***
 * 用户登陆
 * @param username
 * @param password
 * @param code
 * @returns {Promise<any>}
 */
export const login = ({username, password, code}) => {
  return axios.post('/ssc_golang/v1/user/login', {
    username,
    password,
    captcha: code
  });
};

export const getProfile = () => {
  return axios.get('/ssc_golang/v1/user/profile?random='+new Date().getTime());
};

/***
 * 修改密码
 */

export const password = ({
                           old_password,
                           password,
                           password_confirm
                         }) => {
  return axios.post('/ssc_golang/v1/user/member/password', {
    old_password,
    password,
    password_confirm
  });
};

export const changeMarket = ({
  market
}) => {
return axios.post('/ssc_golang/v1/user/member/market', {
market
});
};

/***
 * 退出登录
 */
export const logout = () => {
  return axios.get('/ssc_golang/v1/user/logout?random='+new Date().getTime());
};

//资金明细
export const getAccountLog = ({offset, limit}) => {
  return axios.get('/ssc_golang/v1/user/member/account?random='+new Date().getTime(), {
    params: {
      offset,
      limit
    }
  }).then(info => {
    if (info.result === 'ok') info.data = info.data || [];
    return info;
  });
};


// WEBPACK FOOTER //
// ./src/service/user.js